import  Axios  from "axios";

export const getReverseGeoCode = async (address) => {
    try {
        let result = await Axios.get(`https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyAMRA7ZCZ9hUFFrd6jX2fDfNfIdcY5wMKw&address=${address}`);
        return result
    } catch (error) {
        throw error
    }
}